import React from 'react';
import ReactApexChart from 'react-apexcharts';

const GroupedBarMultipleLineChart = ({ graphData }) => {
  const forecastData = graphData.map(item => item.Forecast || 0);
  const actualsData = graphData.map(item => item.Actuals || 0);
  const priorMissesData = graphData.map(item => item.prior_misses || 0);
  const outboundInboundData = graphData.map(item => item.Outbound_Inbound || 0);
  const outboundInbound20Data = graphData.map(item => item.Outbound_Inbound_20 || 0);
  const originalOBScheduleData = graphData.map(item => item.Original_OB_Schedule || 0);
  const categories = graphData.map(item => item.X_Axis || 'N/A');
  const remainingCapacity = graphData.map(item => item.Remaining_capacity === 0 ? null : item.Remaining_capacity || 0);

  const options = {
    series: [
      {
        name: 'Actuals',
        type: 'column',
        group: 'actuals',
        data: actualsData
      },
      {
        name: 'Forecast',
        type: 'column',
        data: forecastData,
        stack: 'forecastStack'
      },
      {
        name: 'Prior Misses',
        type: 'column',
        data: priorMissesData,
        stack: 'forecastStack'
      },
      // {
      //   name: 'Remaining capacity',
      //   type: 'column',
      //   data: remainingCapacity,
      //   stack: 'forecastStack',
      //   strokeDashArray: 4
      // },
      {
        name: 'Outbound + Inbound',
        type: 'line',
        data: outboundInboundData,
        yAxisIndex: 1,
      },
      {
        name: 'OB+IB+20%',
        type: 'line',
        data: outboundInbound20Data,
        yAxisIndex: 1,
      },
      {
        name: 'Original OB Schedule',
        type: 'line',
        data: originalOBScheduleData
      },
    ],
    chart: {
      toolbar: {
        show: false
      },
      type: 'line',
      stacked: true,
      height: 500,
    },
    stroke: {
      width: [0, 0, 0, 2.5, 2.5, 2.5],
      colors: ['#01B2AA', "#0067A1", "#E01F29", "#0a5e2c"],
      curve: "straight",
      dashArray: [0, 0, 0, 4, 0, 0]
    },
    grid: {
      show: false,
      borderColor: '#e7e7e7',
      strokeDashArray: 0,
      xaxis: {
        lines: {
          show: false
        }
      },
      yaxis: {
        lines: {
          show: true,
          borderColor: '#000000',
          strokeWidth: 2
        }
      }
    },
    annotations: {
      yaxis: [
        {
          y: 0,
          borderColor: '#000000',
          borderWidth: 2,
          strokeDashArray: 100000,
        }
      ],
      points: [
        {
          x: categories[categories.length - 1],
          // y: remainingCapacity[remainingCapacity.length - 1] || 0,
          marker: {
            size: 0
          },
          label: {
            text: 'Remaining Straight Time Capacity',
            style: {
              fontSize: '10px',
              color: '#000',
              background: '#fff',
              padding: '5px 100px 5px 100px', // Padding: top, right, bottom, left
              textAlign: 'center',
            },
            position: 'bottom',
            offsetY: 25,
          }
        }
      ]
    },
    dataLabels: {
      enabled: false,
      formatter: (val) => {
        return (val / 1000000).toFixed(2) + 'M';
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '20%',
        borderRadius: 4,
        borderRadiusWhenStacked: 'first',
        borderColors: ['#000000'],
        borderWidth: 2
      },
    },
    xaxis: {
      categories: categories,
      axisBorder: {
        show: false,
      },
      crosshairs: {
        show: true,
      }
    },
    fill: {
      opacity: 1
    },
    colors: ['#EC6FBD', "#A4D65D", '#EC797F', '#82ffe6ff', "#0067A1", "#3733B8", "#8D6F64"],
    yaxis: {
      labels: {
        formatter: (val) => {
          return '$' + (val / 1000000).toFixed(2) + 'M';
        }
      },
      axisBorder: {
        show: false,
      },
      forceNiceScale: true,
      title: {
        text: 'Throughput NPS $',
        style: {
          fontSize: '12px',
          fontFamily: 'Poppins, sans-serif',
          fontWeight: 500,
          color: "#333"
        }
      }
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      markers: {
        width: 12,
        height: 12,
        radius: 10,
      },
    }
  };

  return (
    <div className="grouped-bar-line-chart">
      <ReactApexChart options={options} series={options.series} type="line" height={400} />
    </div>
  );
};

export default GroupedBarMultipleLineChart;
